import { rem } from 'polished'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const MessagesListSkeleton = styled.div`
  display: grid;
  grid-template-areas:
    "message ."
    ". receivedMessage";
  grid-gap: ${rem(8)};
`

const MessageSkeleton = styled.div`
  grid-area: message;
  display: grid;
  grid-template-areas:
    "avatar message-content";
  grid-template-columns: min-content 1fr;
  grid-gap: ${rem(2)};
  align-items: flex-end;
  height: ${rem(38)};
`

const ReceivedMessageSkeleton = styled(MessageSkeleton)`
  grid-template-areas:
      "message-content avatar";
  grid-area: receivedMessage;
  grid-template-columns: 1fr min-content;
  height: ${rem(54)};
`

const AvatarSkeleton = styled(LoadingBox)`
  grid-area: avatar;
  width: ${rem(24)};
  height: ${rem(24)};
  border-radius: 100%;
`

const MessageContentSkeleton = styled(LoadingBox)`
  grid-area: message-content;
  width: 100%;
  height: 100%;
  border-radius: ${rem(4)};
`

function MessagesLoadingSkeleton() {
  return <MessagesListSkeleton>
    <MessageSkeleton>
      <AvatarSkeleton />
      <MessageContentSkeleton />
    </MessageSkeleton>
    <ReceivedMessageSkeleton>
      <MessageContentSkeleton />
      <AvatarSkeleton />
    </ReceivedMessageSkeleton>
  </MessagesListSkeleton>
}

export default MessagesLoadingSkeleton
